var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"xm-sidebar"},_vm._l((_vm.menus),function(route){return _c('div',{key:route.title},[_c('router-link',{attrs:{"to":route.path}},[_vm._v("\n      "+_vm._s(route.title)+"\n    ")])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }